import { RefObject, useEffect } from 'react';

export const useFocusWhenEnabled = (
  elementRef: RefObject<HTMLElement | null>,
  { focused, disabled }: { focused: boolean; disabled?: boolean }
) => {
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    if (!focused) {
      element.blur();
      return;
    }

    if (!disabled) {
      element.focus();
    }
  }, [elementRef, focused, disabled]);
};
